import useSiteTranslation from '@/providers/i18n/hooks/useSiteTranslation';
import { PAGE_TEXTS_KEYS } from '../../../../../../../constants/constant';
import { Button } from '../../../../ui/button';
import { CardContent } from '../../../../ui/card';
import InputField from '../../../../ui/customInput/input';
const Index = ({
  FORM_FIELD_SPECS,
  searchParams,
  handleSubmitConfirmationId,
  registerConfirmationId,
  confirmationIdErrors,
  onSubmit,
  selectedSearchType,
  resetFormOnInteraction,
  formWrapperKey,
  setFormWrapperKey,
  setSearchParams,
}: any) => {
  const Texts = useSiteTranslation(PAGE_TEXTS_KEYS?.customerAndOrderSearch);
  return (
    <section className="lg:w-1/2">
      <form
        onSubmit={handleSubmitConfirmationId(onSubmit)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleSubmitConfirmationId(onSubmit)();
          }
        }}
      >
        <span className="absolute left-1/2 top-0 hidden h-[90%] w-[1px] bg-[#C6C6C6] lg:block"> </span>
        <span className="absolute inset-0 left-1/2 -ml-4 -mt-4 hidden h-8 w-8 rounded-[50%] bg-white text-center font-bold leading-[30px] text-black lg:top-1/2 lg:block">
          {Texts?.identifierOr}
        </span>
        <section className="px-10">
          <CardContent className="space-y-2">
            <div className="mb-5 flex justify-between" key={formWrapperKey?.[FORM_FIELD_SPECS?.confirmationId?.id]}>
              <InputField
                items={`${Texts?.confirmationId}`}
                id={FORM_FIELD_SPECS?.confirmationId?.id}
                htmlFor={FORM_FIELD_SPECS?.confirmationId?.id}
                register={registerConfirmationId}
                errors={confirmationIdErrors}
                label={Texts?.confirmationId}
                classname="w-full"
                rules={{
                  required: Texts?.confirmationIdRequired,
                }}
                defaultValue={searchParams?.[FORM_FIELD_SPECS?.confirmationId?.id]}
                maxLength={FORM_FIELD_SPECS?.confirmationId?.maxLength}
                hideError
                onChange={() => {
                  resetFormOnInteraction();
                  setSearchParams({ ...searchParams, [FORM_FIELD_SPECS?.orderId?.id]: '' });
                  setFormWrapperKey({
                    ...formWrapperKey,
                    [FORM_FIELD_SPECS?.orderId?.id]: `key_${selectedSearchType}_${
                      FORM_FIELD_SPECS?.orderId?.id
                    }_${Math.floor(Date.now())}}`,
                  });
                }}
              />
              <Button className="ml-5 h-auto bg-[#002C4E] px-8 text-18 text-white" type="submit">
                <span className="text-lg font-semibold text-white">{Texts?.searchButtonText}</span>
              </Button>
            </div>
            {confirmationIdErrors?.[FORM_FIELD_SPECS?.confirmationId?.id] && (
              <p className="mt-2 text-sm text-scarletRed">
                {confirmationIdErrors[FORM_FIELD_SPECS?.confirmationId?.id]?.message}
              </p>
            )}
          </CardContent>
        </section>
      </form>
    </section>
  );
};

export default Index;
